import React, { useState, useEffect } from 'react';
import { getDatabase, ref, get } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { isWelcomeComplete } from '../utils/welcomeComplete';

const ProtectedRoute = ({ children }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [canAccess, setCanAccess] = useState(false);
    
    const db = getDatabase();
    const auth = getAuth();
    const currentUser = auth.currentUser;
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkUserAccess = async () => {
            if (!currentUser) {
                setIsChecking(false);
                return;
            }

            try {
                const userRef = ref(db, `Users/${currentUser.uid}`);
                const snapshot = await get(userRef);
                
                if (!snapshot.exists()) {
                    navigate('/welcome');
                    return;
                }

                const userData = snapshot.val();
                const isPremium = userData?.isPremium ?? false;

                // Wenn Premium → Zugriff erlaubt (Admin hat freigeschaltet)
                if (isPremium) {
                    setCanAccess(true);
                    return;
                }

                if (!isWelcomeComplete(userData)) {
                    navigate('/welcome');
                    return;
                }

                navigate('/unlock');
                
            } catch (error) {
                console.error('Error checking user access:', error);
                navigate('/welcome');
            } finally {
                setIsChecking(false);
            }
        };

        checkUserAccess();
    }, [currentUser, navigate, db]);

    if (isChecking) {
        // SalesGod Loading für /world und /leads Routen
        const isWorldRoute = location.pathname.startsWith('/world') || location.pathname.startsWith('/leads');
        
        if (isWorldRoute) {
            return (
                <>
                    <style>{`
                        @keyframes pr-gradient { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
                        @keyframes pr-rotate { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                        @keyframes pr-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
                    `}</style>
                    <div style={{ 
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        width: '100%', height: '100vh',
                        background: 'linear-gradient(45deg, #ffffff, #f8fbff, #e8f4fd, #ffffff)',
                        backgroundSize: '400% 400%', animation: 'pr-gradient 1s ease infinite'
                    }}>
                        <div style={{ width: '100px', height: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', animation: 'pr-rotate 2s linear infinite' }}>
                            <img src="/img/salesgod_dark.webp" alt="SalesGod" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'contain' }} />
                        </div>
                        <div style={{ fontSize: '18px', fontWeight: '600', color: '#3182ce', fontFamily: 'Inter, sans-serif', animation: 'pr-pulse 1s ease-in-out infinite' }}>Loading...</div>
                    </div>
                </>
            );
        }
        
        return (
            <div className="loading-spinner">
                <h1>BonusClub</h1>
                <div className="spinner-circle"></div>
            </div>
        );
    }

    return canAccess ? children : null;
};

export default ProtectedRoute; 